<template>
  <div class="vb-confirm-view">
    <b-container>
      <section v-if="loading" class="section section--loader">
        <loader size="large" :show_timing_slot="true" />
      </section>

      <section v-if="!loading" class="section">
        <confirm :data="confirm" />
      </section>
    </b-container>
  </div>
</template>

<script>
import { decode_parameters } from "@src/utilities";
import { alpitour_service_handler } from "@alpitour/services/common";
import { alpitour_rybbit_event } from "@alpitour/utilities/rybbit";
import Confirm from "@alpitour/components/views/content-blocks/confirm.vue";
export default {
  name: "confirm-view",
  props: {
    holiday_voucher_id: String,
    confirm_code: String,
  },
  components: {
    confirm: Confirm,
  },
  data() {
    return {
      loading: true,
      confirm: {},
    };
  },
  mounted() {
    if (Object.keys(this.$route.params).length) {
      this.log("IF PARAMS");
      this.params = {
        ...this.params,
        ...this.$route.params,
      };
    }
    if (Object.keys(this.$route.query).length) {
      this.log("IF QUERY");
      let params = decode_parameters(this.$route.query.params);
      this.params = {
        ...this.params,
        ...params,
      };
    }

    this.get_confirm();
  },
  methods: {
    get_confirm() {
      alpitour_service_handler("confirm", {
        holidayVoucherId: this.holiday_voucher_id,
        confirmcode: this.confirm_code,
      })
        .then(
          (success) => {
            this.log("[confirm.vue] - success");
            this.log(success.data);

            const { data: confirmation_data = {} } = success;
            const { sololandVoucher } = confirmation_data;

            // The two vouchers MUST be exclusive so they should never be both missing or both present
            // which is why the order of this expression should not matter
            if (sololandVoucher && confirmation_data.holidayVoucher) {
              alpitour_rybbit_event("error:voucher:conflict", {
                sololand_voucher_id: String(sololandVoucher.voucherId || ""),
                holiday_voucher_id: String(confirmation_data.holidayVoucher.voucherId || ""),
                confirm_code: this.confirm_code || "",
              });
            }

            if (sololandVoucher) {
              this.confirm = sololandVoucher;
              return;
            }
            this.confirm = confirmation_data;
          },
          (error) => {
            this.log("[confirm.vue] - error");
            this.log(error.response);

            this.confirm = {};
          },
        )
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
